import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLoader: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLoader"><Path d="M12.0003 2.5V6.5M12.0003 17.5V21.5M2.5 12.0007H6.5M17.5 12.0007H21.5M5.28271 5.28226L8.11113 8.11069M15.8893 15.8889L18.7177 18.7173M5.28299 18.718L8.11142 15.8896M15.8896 8.11142L18.718 5.28299" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLoader;
